import { render, staticRenderFns } from "./fileMetaEditor.vue?vue&type=template&id=8564738c&scoped=true&"
import script from "./fileMetaEditor.vue?vue&type=script&lang=js&"
export * from "./fileMetaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8564738c",
  null
  
)

export default component.exports